import React from "react";

import Container from "../components/container";
import Layout from "../components/layout";

const TermsAndConditions = () => {
  return (
    <Layout>
      <Container className="py-[48px]">
        <h2 className="heading" style={{ marginBottom: "1.5rem" }}>
          Termini e condizioni
        </h2>

        <div className="text-base">
          <ol start={1}>
            <li>
              <strong className="underline">Condizioni generali In Buona Salute
                S.r.l./Pazienti In Buona Salute S.r.l.
              </strong>
              <br />1.1. In Buona Salute S.r.l. Società Benefit,
              con sede legale in Milano (MI), Piazzale Giulio Cesare 4,
              20145, capitale sociale Euro 120.000,00, interamente versato,
              iscritta al registro delle imprese di Milano
              al n. 13561940969 (la “<strong>In Buona Salute</strong>”),
              è una struttura sanitaria che eroga servizi sanitari,
              psicologici, psicoterapeutici e psiconcologici,
              e tutti gli ulteriori trattamenti complementari
              ai predetti servizi (i “<strong>Servizi</strong>”),
              per mezzo della piattaforma online di esclusiva proprietà di In Buona Salute
              (la “<strong>Piattaforma</strong>”).<br />
              1.2. Le presenti condizioni generali (le “Condizioni Generali”)
              disciplinano l’acquisto da parte dei Pazienti
              (come di seguito definiti) dei Servizi.
            </li>
          </ol>
          <ol start={2}>
            <li>
              <strong className="underline">
                Definizioni
              </strong>
              <br />2.1. Ai fini delle presenti Condizioni Generali.
              <br/>− “<strong>Paziente</strong>” indica la persona fisica che acquista ed usufruisce
              dei Servizi di In Buona Salute per mezzo della Piattaforma.
              <br/>− “<strong>Utente Convenzionato</strong>” indica la persona giuridica
              con cui In Buona Salute ha raggiunto uno specifico accordo
              per l’emissione di voucher o codici sconto aventi ad oggetto
              l’erogazione dei Servizi in favore di terzi – quali,
              a titolo esemplificativo e non esaustivo, dipendenti, collaboratori, clienti.
              <br/>− “<strong>Professionista</strong>” indica lo psicologo, psiconcologo,
              psicoterapeuta, o qualsiasi ulteriore professionista che si riveli necessario
              ai fini del percorso di sostegno psiconcologico, iscritto sulla Piattaforma
              che esercita la propria professione in favore
              del Paziente per mezzo della Piattaforma.
              <br/>− “<strong>Contratto</strong>” indica il
              contratto tra il Paziente e In Buona Salute,
              che si riterrà concluso con l’accettazione delle Condizioni
              Generali da parte del Paziente per mezzo della Piattaforma.
              <br/>− “<strong>GDPR</strong>” indica il Regolamento UE 679/2016
              in materia di protezione dei dati personali.
            </li>
          </ol>
          <ol start={3}>
            <li>
              <strong className="underline">
                Registrazione – Erogazione di Servizi – Abbinamento tra Paziente e Professionista
              </strong>
              <br />3.1. In Buona Salute eroga i Servizi per mezzo di prestazioni
              a distanza fornite dal Professionista in favore del Paziente sulla Piattaforma.
              <br />3.2. Previa accettazione dell’informativa privacy
              e del trattamento dei dati personali,
              il Paziente sarà tenuto alla compilazione di un questionario
              in relazione alle sue esigenze ed al tipo di percorso
              di sostengo psiconcologico che intende seguire.
              Una volta completato il questionario verrà effettuato in tempo
              reale l’abbinamento tra Paziente e Professionista assegnato.
              <br />3.3. L’abbinamento tra Paziente e Professionista sarà effettuato
              sulla base di un sistema di matchmaking basato sulle risposte fornite
              dal Paziente al predetto questionario online.
              <br />3.4. L’utilizzo dei Servizi è consentito ai Pazienti maggiorenni.
              <br />3.5. Il Paziente potrà usufruire dei Servizi con il Professionista
              assegnato dopo essersi registrato sulla Piattaforma, accettando
              l’informativa privacy e le Condizioni Generali, previa lettura
              e sottoscrizione del consenso informato
              al trattamento sanitario fornito dal Professionista.
              <br />3.6. Le sedute tra Professionisti e Pazienti si svolgeranno in videochiamata
              per mezzo della Piattaforma, potendo altresì usufruire del servizio
              di messaggistica presente sulla Piattaforma. Le stesse dovranno
              svolgersi senza la presenza di terzi non autorizzati ed in
              luoghi che garantiscano la privacy della seduta. È assolutamente
              vietata la registrazione, videoregistrazione, nonché la diffusione
              delle informazioni e dei contenuti condivisi nel corso della seduta.
              I contenuti delle sedute e le informazioni ottenute nel
              corso delle stesse saranno trattati/e esclusivamente dal Professionista,
              il quale avrà l’obbligo di conservarli/e, non divulgarli/e e
              mantenerli/e strettamente riservati/e sotto la sua esclusiva responsabilità.
              In Buona Salute in nessun caso potrà essere responsabile dell’eventuale
              divulgazione dei contenuti e/o delle informazioni relative ai Pazienti
              condivisi/e nel corso delle sedute con il Professionista.
              <br />3.7. I contenuti degli incontri tra i Professionisti ed i Pazienti saranno
              mantenuti dagli stessi secretati in conformità alla normativa vigente,
              alla legge professionale e al codice deontologico, salva in
              ogni caso la possibilità di condividere gli stessi con il Direttore
              Sanitario e con le autorità competenti, ove richiesto dalle norme applicabili.
              <br />3.8. Le norme di cui al presente articolo 3 si applicheranno
              anche ai terzi che usufruiranno dei Servizi in virtù di specifici
              accordi con Utenti Convenzionati, salvo diverso accordo con gli stessi.
            </li>
          </ol>
          <ol start={4}>
            <li>
              <strong className="underline">
                Prenotazione della seduta
              </strong>
              <br />4.1. Ove il Paziente e il Professionista decidano di intraprendere il
              percorso di sostegno psiconcologico, le sedute successive dovranno
              essere prenotate dal Paziente mediante l’apposita sezione della Piattaforma
              sulla base delle disponibilità del Professionista. La conferma della
              prenotazione sarà automatica.
              <br/>4.2. Il giorno e l’orario degli appuntamenti potranno essere modificati
              dal Paziente e dal Professionista utilizzando il sistema di messaggistica
              presente sulla Piattaforma.
              <br/>4.3. Il Paziente si impegna a comunicare, tramite la Piattaforma,
              l’eventuale necessità di modificare o cancellare la prenotazione
              effettuata con almeno 24 ore di preavviso.
              Ove tale termine non venga rispettato, la cancellazione o la modifica
              della prenotazione non sarà possibile e:
              <br/>(i) In Buona Salute tratterrà l’importo pagato dal Paziente a titolo di penale;
              <br/>(ii) nel caso in cui sia stato utilizzato un voucher o buono sconto emesso
              in virtù di un accordo con un Utente Convenzionato,
              lo stesso sarà annullato non potrà più essere utilizzato
              (restando inteso che nell’ipotesi di voucher o buono sconto per più sedute,
              solo quella prenotata sarà annullata).
            </li>
          </ol>
          <ol start={5}>
            <li>
              <strong className="underline">
                Prezzo
              </strong>
              <br />5.1. Per usufruire dei Servizi, il Paziente sarà tenuto a pagare
              In Buona Salute il prezzo indicato sulla Piattaforma (il “Prezzo”).
              <br />5.2. Il Paziente, previo inserimento dei dati di
              fatturazione ed eventualmente previo rilascio del consenso per
              la trasmissione delle relative fatture al Sistema Tessera Sanitaria,
              si impegna a pagare il Prezzo in via anticipata. Resta inteso che,
              ove richiesto, la Società si impegnerà alla trasmissione delle fatture
              al Sistema Tessera Sanitaria.
              <br />5.3. In caso di convenzione con un Utente Convenzionato,
              il Paziente potrà sostituire il pagamento del Prezzo con l’inserimento
              degli estremi identificativi del buono sconto o del voucher emesso da In Buona Salute.
              <br />5.4. Qualora la seduta non possa essere eseguita per il malfunzionamento
              della Piattaforma per motivi direttamente imputabili a In Buona Salute,
              il Prezzo verrà riaccreditato automaticamente in favore del Paziente.
              <br />5.5. Le transazioni, così come la conservazione dei dati delle carte,
              avvengono tramite il servizio Stripe.
              In Buona Salute è estranea a tale procedura e non potrà essere
              ritenuta responsabile dei danni che dovessero essere patiti dal
              Paziente in ragione dell’improprio utilizzo
              o malfunzionamento dei sistemi di pagamento.
            </li>
          </ol>
          <ol start={6}>
            <li>
              <strong className="underline">
                Obblighi e responsabilità di In Buona Salute
              </strong>
              <br/>6.1. In Buona Salute si impegna a garantire il funzionamento e
              la manutenzione della Piattaforma per la corretta erogazione dei Servizi.
              <br/>6.2. Resta inteso che In Buona Salute è esonerata da qualsiasi
              responsabilità per il mancato o ritardato adempimento delle proprie
              obbligazioni o in relazione alla mancata erogazione dei Servizi per
              mezzo della Piattaforma per motivi dovuti ad eventi di forza maggiore.
              Ai fini delle presenti Condizioni Generali, per cause di forza maggiore
              si intende il verificarsi di un evento o di una circostanza non prevedibile
              e fuori dal controllo di In Buona Salute che preclude a quest’ultima
              l’adempimento di una o più delle sue obbligazioni
              di cui alle presenti Condizioni Generali.
              A titolo esemplificato, ma non esaustivo, si intendono casi di
              forza maggiore : guerra (dichiarata o meno), invasione, atti di nemici stranieri,
              ampia mobilitazione militare; guerra civile, sommossa, ribellione e rivoluzione,
              atti di terrorismo, sabotaggio o pirateria, restrizioni valutarie e commerciali,
              epidemia, calamità naturali o eventi naturali estremi; esplosione, incendio,
              distruzione di attrezzature, interruzione prolungata delle telecomunicazioni,
              dei sistemi informatici o dell’energia; malfunzionamento della rete
              internet e/o dei dispositivi elettronici anche mobili, black-out,
              perturbazioni generali del lavoro quali boicottaggio, sciopero e serrata,
              rallentamento deliberato del ritmo di lavoro (go–slow).
              <br/>6.3. Al verificarsi di uno dei predetti casi di forza maggiore,
              In Buona Salute ne darà immediata comunicazione al Paziente,
              avvertendolo della sospensione del servizio. L’obbligo di adempiere
              le obbligazioni di cui alle presenti Condizioni Generali si intenderà
              sospeso per tutto il periodo in cui perdurerà la causa di forza maggiore.
              <br/>6.4. Resta inteso che, nel caso in cui si verifichi una causa di
              forza maggiore e la prenotazione venga cancellata, il Paziente avrà diritto
              solo al rimborso del Prezzo versato per la/le seduta/e prenotate e non usufruita/e.
              <br/>6.5. In Buona Salute non potrà essere responsabile per eventuali danni,
              pretese o perdite, dirette o indirette, in caso di disfunzioni o sospensioni
              del servizio a causa di terzi (quali, a titolo esemplificativo e non esaustivo,
              malfunzionamenti dell’hosting e della rete internet), così come da eventuali
              problematiche nell’accesso alla Piattaforma per motivi di connessione o per
              eventuali malfunzionamenti tecnici riconducibili ai Pazienti,
              ai Professionisti e/o a terzi.
              <br/>6.6. Resta in ogni caso inteso che, nell’ipotesi in cui venga accertata
              la responsabilità di In Buona Salute, il Paziente accetta espressamente che
              il risarcimento del danno sarà limitato alla restituzione degli importi già
              pagati per le sedute prenotate e non usufruite, con espressa
              esclusione di qualsiasi risarcimento di danno ulteriore, diretto o indiretto.
              <br/>6.7. In Buona Salute non potrà essere in alcun caso responsabile
              dell’eventuale utilizzo fraudolento ed illecito da parte di terzi, di carte
              di credito, assegni ed altri mezzi di pagamento, all’atto del versamento del Prezzo.
              <br/>6.8. In Buona Salute sarà responsabile della prestazione sanitaria
              resa ai sensi dell’articolo 7 della L.24/2017, ad eccezione del caso in cui
              il Professionista abbia agito dopo aver assunto un’obbligazione contrattuale
              direttamente con il Paziente, e fatta in ogni caso salva l’azione di
              rivalsa da parte di In Buona Salute nei confronti del Professionista.
            </li>
          </ol>
          <ol start={7}>
            <li>
              <strong className="underline">
                Selezione dei Professionisti
              </strong>
              <br/>7.1. In Buona Salute non assume alcuna responsabilità in merito
              all’abbinamento tra Paziente e Professionista restando nella discrezione
              del Paziente scegliere se intraprendere il percorso di sostegno psiconcologico con
              il Professionista selezionato.
              <br/>7.2. Eventuali problematiche dovessero insorgere tra Paziente
              e Professionista dovranno essere comunicate da parte del Paziente alla
              seguente e-mail: supporto@inbuonasalute.eu. In Buona Salute si impegnerà
              a verificare le problematiche riscontrate e, ove necessario, a mettere in
              contatto il Paziente con un altro Professionista.
              <br/>7.3. Il Professionista ha la possibilità di interrompere il
              rapporto con il Paziente in qualsiasi momento, solo ed esclusivamente
              per motivi clinici o per motivi legati esclusivamente all’interesse del
              Paziente. In tal caso, ovvero nell’ipotesi in cui dovesse interrompersi
              il rapporto tra In Buona Salute ed il Professionista, In Buona Salute si
              impegna a fornire al Paziente il contatto di un nuovo Professionista entro
              7 (sette) giorni da detta interruzione.
            </li>
          </ol>
          <ol start={8}>
            <li>
              <strong className="underline">
                Obblighi del Paziente
              </strong>
              <br/>8.1. Accettando le presenti Condizioni Generali il Paziente dichiara:
              <br/>(a) di essere maggiorenne; ovvero
              <br/>(b) nel caso di acquisto dei Servizi per conto di terzi
              (quali minori di età), di essere legittimato e/o autorizzato
              alla prenotazione ed alla registrazione nell’interesse di tali terzi.
              <br/>8.2. Una volta concluso il Contratto, il Paziente si impegna
              a stampare ed a conservare le Condizioni Generali e ogni sua modifica,
              integrazione e aggiornamento successivo.
              <br/>8.3. È assolutamente vietato al Paziente inserire dati e/o informazioni
              false, inventate o di terzi senza la necessaria legittimazione
              e/o autorizzazione nella fase di registrazione sulla Piattaforma,
              così come in tutte le ulteriori fasi relative all’erogazione ed alla
              fruizione dei Servizi. È altresì vietato eseguire doppie registrazioni
              o far accedere terze persone per mezzo del proprio account.
              <br/>8.4. In Buona Salute si riserva di avviare tutte le azioni
              legali necessarie nell’ipotesi in cui il Paziente assuma una condotta
              in violazione rispetto alle predette disposizioni.
              <br/>8.5. Il Paziente garantisce la veridicità delle informazioni
              fornite, che potranno essere verificate da parte di In Buona Salute,
              il quale, in caso di informazioni non veritiere, avrà diritto
              insindacabile di negare l’accesso alla Piattaforma.
              Il Paziente si impegna ad aggiornare costantemente le informazioni
              fornite al momento della propria registrazione e manleverà
              In Buona Salute da qualsiasi responsabilità derivante dalla
              comunicazione di dati non veritieri/non aggiornati.
            </li>
          </ol>
          <ol start={9}>
            <li>
              <strong className="underline">
                Violazioni delle Condizioni Generali – Clausola risolutiva espressa
              </strong>
              <br/>9.1. Nell’ipotesi in cui il Pazienti violi le Condizioni Generali,
              In Buona Salute avrà la facoltà di sospendere o bloccare, in tutto o in parte,
              l’accesso ai Servizi ed alla Piattaforma da parte del Paziente, in modo temporaneo
              o definitivo, senza preavviso e senza il riconoscimento di alcun rimborso degli
              importi già corrisposti, riservandosi la possibilità avviare tutte le azioni
              necessarie per la tutela dei propri interessi.
              <br/>9.2. L’eventuale violazione delle obbligazioni del Paziente
              di cui agli articoli 5, 8, 11, determinerà la risoluzione del Contratto
              ai sensi dell’articolo 1456 del codice civile, fatto in ogni caso salvo
              il diritto di In Buona Salute di richiedere il risarcimento del danno subito.
              <br/>9.3. Il Contratto si intenderà risolto dal momento in cui
              In Buona Salute comunica al Paziente a mezzo e-mail
              la sua intenzione di avvalersi della predetta clausola risolutiva espressa.
            </li>
          </ol>
          <ol start={10}>
            <li>
              <strong className="underline">
                Trattamento dei dati personali
              </strong>
              <br/>10.1. La Piattaforma tratta i dati personali dei Pazienti nel
              rispetto di quanto disposto dal D.lgs. 196/2003, così come modificato
              dal D.lgs. 101/2018 e ss.mm. (di seguito, “Codice Privacy”)
              e dei relativi allegati, nonché nel rispetto del Regolamento
              UE 2016/679 (di seguito il “Regolamento” o “GDPR”), del quale
              sono qui integralmente richiamate le definizioni, e di ogni
              altra normativa, provvedimento anche secondario, linee guida
              del Garante per la Protezione dei Dati Personali,
              best practice applicabili in materia di protezione dei dati personali.
              <br/>10.2. Al momento della registrazione, ogni Paziente è tenuto a prendere
              visione dell’informativa privacy e, laddove necessario, a fornire mediante
              selezione tramite “flag” il/i proprio/i consenso/i al trattamento
              dei dati personali che lo riguardano.
              <br/>10.3. In Buona Salute è Titolare del trattamento dei dati personali
              dei Pazienti e li trasmette al/ ai Professionisti, che operano in qualità
              di Responsabili del trattamento ex art. 28 GDPR, laddove il Paziente decida
              di iniziare il percorso di sostegno psiconcologico, per le finalità indicate
              nell’informativa privacy, nel rispetto delle istruzioni fornite al Professionista,
              come previsto nell’accordo di designazione
              a Responsabile (DPA) sottoscritto tra le Parti.
              <br/>10.4. Il sistema di archiviazione dei dati, i servizi e i dati back-end
              della Piattaforma utilizzano server ospitati da terze
              parti che si trovano nel territorio dell’UE.
              <br/>10.5. Per ogni dettaglio in relazione al trattamento dei dati
              personali del Paziente, si rinvia all’informativa privacy presente sulla Piattaforma.
            </li>
          </ol>
          <ol start={11}>
            <li>
              <strong className="underline">
                Utilizzo della Piattaforma
              </strong>
              <br/>11.1. La Piattaforma potrà essere utilizzata al solo
              scopo di usufruire dei Servizi ed è vietato qualsiasi altro
              diverso utilizzo. In Buona Salute non fornisce alcuna assistenza
              in situazioni di emergenza, per cui invita i Pazienti a contattare
              i numeri di emergenza relativi alla situazione di emergenza.
              <br/>11.2. Il Paziente, a mero titolo esemplificativo e non esaustivo,
              non potrà copiare, riprodurre, pubblicare, i contenuti e le
              caratteristiche della Piattaforma, così come non potrà utilizzare
              il know-how, i materiali, le idee, le immagini e il format della Piattaforma.
              <br/>11.3. In caso di violazione delle disposizioni del presente articolo,
              In Buona Salute potrà risolvere il Contratto ai sensi dell’articolo 1456
              del codice civile e potrà avviare tutte le azioni necessarie per
              il risarcimento del danno subito.
            </li>
          </ol>
          <ol start={12}>
            <li>
              <strong className="underline">
                Modifica delle Condizioni Generali
              </strong>
              <br/>12.1. Le Condizioni Generali sono rese disponibili a favore dei singoli
              utenti ai sensi dell’articolo 12 del D.lgs. 9 aprile 2003, n. 70.
              <br/>12.2. Le Condizioni Generali possono essere aggiornate,
              integrate o modificate con immediata efficacia per il futuro,
              in qualsiasi momento da parte di In Buona Salute,
              previa comunicazione per mezza della Piattaforma.
              Resta espressamente inteso che l’utilizzo della Piattaforma a seguito
              di dette modifiche comporta espressa presa
              di coscienza e accettazione delle modifiche,
              integrazioni ed aggiornamenti apportati da In Buona Salute.
              <br/>12.3. Per la conclusione del Contratto le Condizioni
              Generali dovranno essere espressamente accettate da parte del Paziente.
              <br/>12.4. Resta in ogni caso che le Condizioni Generali si intendono
              espressamente ed incondizionatamente accettate a seguito della conferma
              della prenotazione della visita da parte del Paziente.
              <br/>12.5. Il Contratto è regolato, inter alia, dalle disposizioni del
              D.lgs. 6 settembre 2005 n. 206 (“Codice del Consumo”).
              <br/>12.6. La Piattaforma si serve di cookies. Per maggiori
              informazioni al riguardo si rimanda alla Cookie policy indicata sulla Piattaforma.
            </li>
          </ol>
          <ol start={13}>
            <li>
              <strong className="underline">
                Diritto di recesso
              </strong>
              <br/>13.1. In considerazione di quanto previsto dalle
              presenti Condizioni Generali il Paziente accetta espressamente
              di perdere il diritto di recesso, ai sensi dell’articolo 59,
              comma 1, lett. a) del Decreto Legislativo 6 settembre 2005,
              n. 206 (“Codice del Consumo”),
              una volta usufruito del Servizio erogato da In Buona Salute.
            </li>
          </ol>
          <ol start={14}>
            <li>
              <strong className="underline">
                Cessazione del Contratto
              </strong>
              <br/>14.1. Nell’ipotesi in cui il Paziente non intenda usufruire dei Servizi,
              dovrà provvedere alla eliminazione del proprio account personale sulla Piattaforma.
            </li>
          </ol>
          <ol start={15}>
            <li>
              <strong className="underline">
                Nullità parziale
              </strong>
              <br/>15.1. Nell’ipotesi in cui una clausola
              o parte delle Condizioni Generali,
              informativa privacy o Cookie policy di In Buona Salute venisse
              dichiarata nulla, invalida, illecita o illegittima,
              non andrà ad intaccare la validità ed efficacia delle altre previsioni,
              che resteranno pienamente valide ed efficaci.
            </li>
          </ol>
          <ol start={15}>
            <li>
              <strong className="underline">
                Legge applicabile e foro competente
              </strong>
              <br/>16.1. Le presenti Condizioni Generali sono regolate dalla legge italiana.
              <br/>16.2. Qualsiasi divergenza o controversia che possa sorgere o intervenire
              tra In Buona Salute e il Paziente in relazione a qualsiasi questione derivante
              da o connessa alle Condizioni Generali – incluse in via meramente
              esemplificativa quelle derivanti dalla loro interpretazione,
              applicazione e/o esecuzione – sarà soggetta, senza eccezione,
              alla giurisdizione esclusiva del Tribunale di Milano.
            </li>
          </ol>
        </div>
      </Container>
    </Layout>
  );
};

export default TermsAndConditions;
